"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mui_1 = require("tss-react/mui");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const HelpOutline_1 = __importDefault(require("@mui/icons-material/HelpOutline"));
const QCheckbox_1 = __importDefault(require("components/QCheckbox"));
const QTip_1 = __importDefault(require("components/QuickenControls/QTip"));
const styles_1 = require("./styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
/*
 CATEGORY MENU HEADER (QUICKEN ONLY) - this is the addition to the category field
 */
const CategoryMenuHeader = ({ boxClick, checked, payee }) => {
    const { classes } = useStyles();
    return (<div className={classes.headerContainer}>
      <div style={{ display: 'flex', alignItems: 'flex-start' }}>
        <QCheckbox_1.default onClick={boxClick} checked={checked} classes={{ boxBorder: classes.headerCheckboxBorder, root: classes.headerCheckbox }}/>
        <Typography_1.default variant={'body1'} pr={0.4}>
          Apply changes to similar transactions
        </Typography_1.default>
        <QTip_1.default title={'Quicken will look forwards and backwards in ' +
            `your transaction list and update all transactions with the payee name "${payee}" to use the ` +
            'selected category.  Additionally, this "rule" will be applied going forward to downloaded transactions'}>
          <HelpOutline_1.default className={classes.helpIcon}/>
        </QTip_1.default>
      </div>
    </div>);
};
exports.default = CategoryMenuHeader;
